import UIModuleForm from './UIModuleForm';

export default UIModuleForm;
